"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_common_clean_unallowed_keys_inside_object_1 = __importDefault(require("@gcloud-npm/utils.common.clean-unallowed-keys-inside-object"));
const utils_common_make_up_obj_1 = __importDefault(require("@gcloud-npm/utils.common.make-up-obj"));
const utils_common_my_assign_1 = __importDefault(require("@gcloud-npm/utils.common.my-assign"));
/**
 * getUrlParams
 * @param {bool} groupByObject object used to write the final result
 * @param {array} allowedKeys array of RegEx like: allowed: []
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */
const getUrlParams = (arg = {
    groupByObject: false,
    allowedParams: null,
    currentUrl: "",
}) => {
    let params = null;
    const { groupByObject, allowedParams, currentUrl } = arg;
    try {
        const currentUrlObj = new URL(currentUrl);
        const searchParams = new URLSearchParams(currentUrlObj.search);
        params = Object.fromEntries(searchParams.entries());
    }
    catch (err) {
        console.error(err);
    }
    // cleaning function
    if (Array.isArray(allowedParams) && params) {
        params = (0, utils_common_clean_unallowed_keys_inside_object_1.default)(params, allowedParams);
    }
    // group by "." as object
    if (groupByObject) {
        let groupedParams = {};
        Object.entries(params).forEach(([paramsKey, value]) => {
            if (paramsKey.includes(".")) {
                const auxObj = (0, utils_common_make_up_obj_1.default)(paramsKey, value);
                groupedParams = (0, utils_common_my_assign_1.default)(groupedParams, auxObj);
            }
            else {
                groupedParams[paramsKey] = value;
            }
        });
        params = groupedParams;
    }
    return params;
};
exports.default = getUrlParams;
//# sourceMappingURL=index.js.map